import { create } from 'zustand';
import { changeWorkStatus, getWorkStatus } from '../api/user';
import { WorkStatusEnum } from '../types/enum/user';

interface UseBossProcessStoreType {
  processStatus: WorkStatusEnum;
  onStart: () => Promise<void>;
  onPaused: () => Promise<void>;
  // onRestart: () => void;
  init: () => Promise<void>;
}

export const useBossProcessStore = create<UseBossProcessStoreType>((set) => ({
  processStatus: WorkStatusEnum.Stopped,

  init: async () => {
    try {
      const res = await getWorkStatus();
      set({ processStatus: res.data.status });
    } catch (error) {
      console.error(error);
    }
  },
  onStart: async () => {
    try {
      await changeWorkStatus({ status: WorkStatusEnum.Running });
      set({ processStatus: WorkStatusEnum.Running });
    } catch (error) {
      console.error(error);
    }
  },

  onPaused: async () => {
    try {
      await new Promise((resolve) => setTimeout(resolve, 1500)); // 最小等待时间
      await changeWorkStatus({ status: WorkStatusEnum.Stopped });
      set({ processStatus: WorkStatusEnum.Stopped });
    } catch (error) {
      console.error(error);
    }
  },
}));
